import React from 'react';
import BannerLeftSection from './BannerLeftSection';
import BannerRightSection from './BannerRightSection';
import { UIPrepPlan } from 'types';

type Props = {
	progress: number;
	numberOfDays: number;
	prepPlan: UIPrepPlan;
};

const ChallengeBanner = ({ prepPlan, progress, numberOfDays }: Props) => {
	return (
		<div className="pt-[16px] pb-[8px]  border-b border-[#C7C9D9] dark:border-[#555770]">
			<div className="flex flex-col md:flex-row gap-[12px] md:gap-[8px] justify-between">
				<BannerLeftSection prepPlan={prepPlan} />
				<BannerRightSection progress={progress} />
			</div>

			{/* <div className="w-[calc(100%-140px)] md:max-w-[500px] ">
				<p className="text-left font-medium text-lg font-inter text-[#FFF] md:text-xl	md:font-semibold md:leading-6	">
					Your Career Path
				</p>

				<p className="text-[#CDF] text-xs font-inter font-normal mt-2 md:text-base	">
					Get job-ready with our personalised path. Unlock <span className="greenish-gradient-text">FREE</span> round 2
					after Day {numberOfDays}. Your dream tech role awaits!
				</p>
			</div>
			<div className="mt-5 text-[#C7C9D9] text-xs leading-[10px] md:text-base md:leading-[10px] ">
				<p>Overall Progress</p>
			</div>
			<div className="mt-[0.5px] z-10 md:max-w-[500px] ">
				<p className="text-right font-medium text-xs font-inter text-[#7777E7] md:text-base md:leading-[10px]">{`${bannerData.progress}%`}</p>

				<Progress
					progress={bannerData.progress}
					color="purplePlaced"
					className="prepare-banner-progress-bar rounded-[8px] progress-bar md:mt-2 "
				/>
			</div>
			<Img
				src="/assets/personalisedPathBanner.svg"
				alt="personalisedPathBanner"
				className="absolute top-0 right-0 w-[140px] h-[143px] md:w-[171px] md:h-[171px] md:right-28"
			/> */}
		</div>
	);
};

export default ChallengeBanner;
